import { FiTarget, FiTrendingUp, FiCheckCircle, FiLayers, FiUsers, FiSearch, FiLayout, FiGrid, FiSmartphone, FiMonitor, FiRefreshCw } from "react-icons/fi";
import {
  LuBug,
  LuBuilding2,
  LuClipboardList,
  LuClock,
  LuLayoutDashboard,
  LuMousePointerClick,
  LuPalette,
  LuRocket,
  LuShoppingBag,
  LuSmartphone,
  LuUsers,
  LuVideo,
  LuWallet,
} from "react-icons/lu";

export const UiuxHeroData = {
  backgroundImage: "/images/serviceBanners/UI-UXLatest.webp",
  whiteImage: "/images/serviceBanners/UI-UXLatestW.webp",
  subTitle: "UI/UX Design Services",
  title: (
    <>
      Design <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">User Experience</span>
      <br />
      That Drive Engagement
    </>
  ),
  description:
    "We create modern UI/UX designs focused on usability, user engagement, and seamless digital experiences. Our UI/UX design services help businesses improve customer interaction, increase conversions, and build intuitive digital products that deliver smooth experiences across websites, web applications, and mobile platforms.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "User-Centered Design",
      desc: "Create intuitive and engaging digital user experiences.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive UI Layouts",
      desc: "Optimized designs for all devices and screen sizes.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Modern Design Approach",
      desc: "Clean, interactive, and visually appealing interfaces.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Conversion-Focused Experience",
      desc: "Designed to improve engagement and user interaction.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const uiuxBenefits = [
  {
    icon: <FiTarget className="w-8 h-8" color="#a855f7" />,
    title: "Research-Driven Design",
    desc: "Every pixel backed by user research, heatmaps, and data — not gut feeling.",
  },
  {
    icon: <FiTrendingUp className="w-8 h-8" color="#34d399" />,
    title: "Conversion-Optimised UX",
    desc: "Strategic information architecture and micro-interactions that guide users to action.",
  },
  {
    icon: <FiCheckCircle className="w-8 h-8" color="#f59e0b" />,
    title: "Accessibility First",
    desc: "WCAG 2.1 AA compliant designs ensuring your product works for every user.",
  },
  {
    icon: <FiLayers className="w-8 h-8" color="#22d3ee" />,
    title: "End-to-End Ownership",
    desc: "From discovery workshops to dev handoff with Figma specs, assets, and design systems.",
  },
  {
    icon: <FiUsers className="w-8 h-8" color="#a855f7" />,
    title: "Proven Impact",
    desc: "200+ products designed — with avg. 40% improvement in user engagement post-redesign.",
  },
];

export const uiuxServices = [
  {
    icon: <LuVideo size={36} color="#a855f7" />,
    title: "Video Editing Services",
    description:
      "Professional video editing solutions including cuts, transitions, color grading, motion graphics, and sound enhancement to create engaging content for businesses, creators, and brands.",
    image: "/images/video-editing/video-editing-services.webp",
    link: "/video-editing-services-india",
    points: ["Professional Video Editing", "Color Grading & Motion Graphics", "Audio Enhancement & Final Delivery"],
  },
  {
    icon: <FiSearch size={36} color="#a855f7" />,
    title: "UX Research & Strategy",
    description: "User interviews, persona mapping, competitor analysis, and usability audits to build a solid foundation before a single frame is drawn.",
    image: "/images/uiux/UX-Research-Strategy.webp",
    link: "/ux-research-strategy-india",
    points: ["User Research & Analysis", "Competitor & Audience Insights", "UX Strategy Planning"],
  },
  {
    icon: <FiLayout size={36} color="#34d399" />,
    title: "Wireframing & Prototyping",
    description: "Low-fidelity to high-fidelity wireframes and interactive prototypes in Figma for seamless user journeys and stakeholder approval.",
    image: "/images/uiux/Wireframing-Prototyping.webp",
    link: "/wireframing-prototyping-india",
    points: ["Low & High-Fidelity Wireframes", "Interactive Prototyping", "User Flow Mapping"],
  },
  {
    icon: <FiGrid size={36} color="#f59e0b" />,
    title: "UI Design & Design Systems",
    description: "Pixel-perfect, brand-focused UI design with scalable component libraries and consistent design systems.",
    image: "/images/uiux/UI-Design-Systems.webp",
    link: "/ui-design-systems-india",
    points: ["Custom UI Components", "Design System Creation", "Brand-Focused Visual Design"],
  },
  {
    icon: <FiSmartphone size={36} color="#22d3ee" />,
    title: "Mobile App Design",
    description: "Intuitive and platform-native mobile experiences for Android and iOS with exceptional user experience.",
    image: "/images/uiux/Mobile-App-Design.png",
    link: "/mobile-app-design-india",
    points: ["Android & iOS App Design", "Mobile User Experience", "Responsive App Interfaces"],
  },
  {
    icon: <FiMonitor size={36} color="#a855f7" />,
    title: "Web & SaaS Dashboard Design",
    description: "Clean, functional, and data-rich dashboards and admin panels designed for complex SaaS products.",
    image: "/images/uiux/Web-SaaS-Dashboard-Design.png",
    link: "/web-SaaS-dashboard-design-india",
    points: ["SaaS Dashboard Design", "Admin Panel Interfaces", "Data Visualization UI"],
  },
  {
    icon: <FiRefreshCw size={36} color="#34d399" />,
    title: "Usability Testing & Optimization",
    description: "Comprehensive usability testing, user behavior analysis, and continuous iteration to maximize product performance.",
    image: "/images/uiux/Usability-Testing.png",
    link: "/usability-testing-iteration-india",
    points: ["Usability Testing", "User Behavior Analysis", "UI/UX Performance Optimization"],
  },
];
export const uiuxProcessSteps = [
  {
    step: "01",
    title: "Discover & Define",
    description: "Deep-dive into your users, business goals, and competitive landscape to define the design direction.",
    points: ["Stakeholder interviews", "User research & personas", "Jobs-to-be-done mapping"],
  },
  {
    step: "02",
    title: "Wireframe & Architect",
    description: "Structure the information architecture and validate flows before investing in visual polish.",
    points: ["Sitemap & user flows", "Low-fi wireframes", "Clickable prototypes"],
  },
  {
    step: "03",
    title: "Design & Prototype",
    description: "High-fidelity UI design, micro-interactions, and motion design — fully interactive in Figma.",
    points: ["Visual UI design", "Component library", "Interactive prototype"],
  },
  {
    step: "04",
    title: "Test, Handoff & Support",
    description: "Validate with real users, refine, and deliver developer-ready specs with ongoing design support.",
    points: ["Usability testing", "Figma dev handoff", "Post-launch design QA"],
  },
];

export const uiuxFaqs = [
  {
    q: "What tools do you use for UI/UX design?",
    a: "We primarily work in Figma for all design and prototyping. We also use FigJam for workshops, Maze/Useberry for usability testing, and Zeplin or Figma Dev Mode for handoff.",
  },
  {
    q: "How long does a typical UI/UX project take?",
    a: "A focused landing page or feature redesign takes 2–4 weeks. A full product design (mobile app or SaaS) typically takes 6–12 weeks depending on scope and complexity.",
  },
  {
    q: "Do you conduct user research as part of the process?",
    a: "Yes. Every project starts with discovery. We conduct user interviews, analyse analytics, and run usability audits before designing a single screen.",
  },
  {
    q: "Will I receive a design system or component library?",
    a: "Absolutely. All projects are delivered with a fully documented Figma design system — components, tokens, typography, and colour styles — ready for your dev team.",
  },
  {
    q: "Do you support design after development begins?",
    a: "Yes. We offer design QA support during development and are available for iteration sprints based on real user feedback post-launch.",
  },
];

export const uiuxTechStack = ["Figma", "Adobe XD", "Sketch", "Canva", "Useberry", "Zeplin", "Lottie", "Framer", "Notion"];

export const uiuxTechIcons = {
  Figma: "images/icons/figma.webp",
  "Adobe XD": "images/icons/adobexd.webp",
  Sketch: "images/icons/sketch.webp",
  Canva: "images/icons/canva.webp",
  Useberry: "images/icons/useberry.webp",
  Zeplin: "images/icons/zeplin.webp",
  Lottie: "images/icons/lottie.webp",
  Framer: "images/icons/framer.webp",
  Notion: "images/icons/notion.webp",
};

export const uiuxSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "UI/UX Design Solutions for Every Business Need",
  buildCards: [
    {
      title: "Mobile App UI/UX Design",
      desc: "Create intuitive and engaging mobile app experiences for Android and iOS platforms.",
      icon: LuSmartphone,
      colorClass: "text-[#22d3ee]",
      bgClass: "bg-[#22d3ee]/10",
      borderClass: "border-[#22d3ee]/20 hover:border-[#22d3ee]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(34,211,238,0.25)]",
    },
    {
      title: "Enterprise Dashboard Design",
      desc: "Design scalable and user-friendly dashboards for enterprise business operations.",
      icon: LuBuilding2,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce UI/UX Solutions",
      desc: "Build seamless shopping experiences with conversion-focused interface designs.",
      icon: LuShoppingBag,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand App Design",
      desc: "Design smooth booking, delivery, and service-based user experiences.",
      icon: LuClock,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech UI/UX Design Services",
      desc: "Create secure and modern fintech interfaces focused on usability and trust.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Custom UI/UX Design Solutions",
      desc: "Tailored UI/UX designs built around unique business goals and user needs.",
      icon: LuPalette,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Our Proven UI/UX Design Process",
  processTitle: "Our Strategic UI/UX Design Approach",
  processSteps: [
    {
      step: "01",
      title: "Research & Discovery",
      description: "We understand your business goals, audience behavior, and design requirements.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "We define user flows, design structure, and experience strategy for better usability.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Wireframing & UI Design",
      description: "We create intuitive wireframes and modern user interface designs focused on engagement.",
      icon: LuLayoutDashboard,
    },
    {
      step: "04",
      title: "Interactive Prototyping",
      description: "We build interactive prototypes to visualize seamless user experiences and workflows.",
      icon: LuMousePointerClick,
    },
    {
      step: "05",
      title: "Usability Testing",
      description: "We test user interactions and optimize designs for better accessibility and performance.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Design Handoff & Support",
      description: "We deliver design-ready assets and provide continuous UI/UX support for development.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "Why Choose Our UI/UX Design Services?",
  benefitsTitle: "Why Businesses Choose UI/UX Design Services",
  benefits: [
    "User-Centered Design Approach",
    "Responsive & Modern Interfaces",
    "Improved User Engagement",
    "Conversion-Focused Design Strategy",
    "Consistent Brand Experience",
    "Scalable Design Systems",
    "Better Usability & Accessibility",
  ],
  logoImage: "/images/serviceBanners/UI-UXLatest.webp",
  whiteLogoImage: "/images/serviceBanners/UI-UXLatestW.webp",
};

export const uiPortfolioData = {
  subtitle: "OUR WORK",
  title: "Ui Design We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};

export const uiuxAboutData = [
  {
    title: "Modern UI/UX Experiences for Digital Products",
    content: (
      <>
        Businesses today require digital experiences that are visually engaging, easy to navigate, and aligned with user expectations. Professional{" "}
        <b className="text-text-primary font-semibold">ui ux design services</b> help companies create intuitive digital platforms that improve customer satisfaction and strengthen
        online interactions. A reliable <b className="text-text-primary font-semibold">ui ux design company</b> focuses on building experience-driven interfaces that support
        business growth across websites, applications, and digital platforms.
      </>
    ),
  },

  {
    title: "Strategic Design Solutions for Better User Interaction",
    content: (
      <>
        Creating effective digital products requires more than attractive visuals. Businesses investing in <b className="text-text-primary font-semibold">website ui ux design</b>{" "}
        focus on improving navigation flow, accessibility, and overall user experience to increase customer retention and engagement. Companies also work with providers offering{" "}
        <a href="https://tychotechnologies.com/ux-research-strategy-india" className="text-cyan-400 underline hover:text-cyan-300">
          ux research services
        </a>{" "}
        to better understand user behavior, audience preferences, and interaction patterns before designing scalable digital experiences.
      </>
    ),
  },

  {
    title: "Scalable UI/UX Design for Web and Mobile Platforms",
    content: (
      <>
        Modern businesses need consistent digital experiences across both web and mobile platforms. Professional{" "}
        <b className="text-text-primary font-semibold">mobile app ui ux design services</b> help brands create seamless user journeys that support usability, functionality, and
        smooth digital interaction. Businesses also collaborate with teams specializing in{" "}
        <a href="https://tychotechnologies.com/wireframing-prototyping-india" className="text-cyan-400 underline hover:text-cyan-300">
          wireframing and prototyping services
        </a>{" "}
        to visualize product structure, validate concepts, and improve user experience before development begins.
      </>
    ),
  },

  {
    title: "Reliable UI/UX Design Services in India",
    content: (
      <>
        The demand for user-focused digital experiences continues to grow across industries including healthcare, education, retail, fintech, and SaaS platforms. Businesses
        searching for scalable design solutions often choose a trusted <b className="text-text-primary font-semibold">ui ux design company in india</b> for modern design strategies
        and experienced creative teams. Companies also rely on professional <b className="text-text-primary font-semibold">ui ux design services india</b> providers to create
        future-ready digital experiences that improve brand perception and support long-term business growth.
      </>
    ),
  },
];
